/**
 * News block sidebar.
 * @module components/manage/Blocks/News/Sidebar
 * @nk24:CMScom created 2021/04/18
 */

import React from 'react';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { defineMessages, injectIntl } from 'react-intl';
import Schema from './Schema';

const messages = defineMessages({
  news: {
    id: 'News',
    defaultMessage: 'News',
  },
});

const Sidebar = (props) => {
  const _ = props.intl.formatMessage;
  const type = props.data['@type'];
  const content = props.data[type];
  if (!content) {
    return null;
  }
  // const schema_data = {
  //   topics: [],
  //   background_image_PC: [],
  //   background_image_SP: [],
  //   target: {},
  //   ...props.data?.[type],
  // };
  return (
    <InlineForm
      schema={Schema}
      title={_(messages.news)}
      onChangeField={(id, value) => {
        props.onChangeBlock(props.block, {
          ...props.data,
          [type]: { ...props.data[type], [id]: value },
        });
      }}
      formData={{
        background_image_PC: content.background_image_PC || [],
        background_image_SP: content.background_image_SP || [],
        topics: content.topics || [],
      }}
    />
  );
};

export default injectIntl(Sidebar);
